import { StageUpdate } from '../types';

import axiosInstance from './axiosInstance';

export async function updateStage(stageUuid: string, update: StageUpdate) {
  await axiosInstance.put(`/stages/${stageUuid}`, update);
}
